import { drawClock } from './clock.mjs'
import { makeChallenge, checkChallenge } from './challenge.mjs'
import { makeButtons } from './buttons.mjs';
import { getScore, getLevel } from './trophy.mjs';

import './clock.css';
import './trophy.css';

getScore();
const level = getLevel();

let difficulty = {
    fiveMinutesInterval: (level > 1) ? false : true,
    clockType: (level > 2) ? 'digital' : 'analog'
};


let challenge = makeChallenge(difficulty);
console.log(challenge);

drawClock(challenge.h, challenge.m, 0, difficulty.clockType);

makeButtons(challenge.solution, challenge.wrong, checkChallenge);

export function refresh() {
    location.reload();
}